/**
 * Force ion-menu to use the active page's ion-content.
 * Idempotent when already bound correctly.
 */
export function rebindCoursesMenu(menuId, contentId) {
  if (!menuId || !contentId) return false;

  const menuEl = document.querySelector(`ion-menu[menu-id="${menuId}"]`);
  const contentEl = document.getElementById(contentId);
  if (!menuEl || !contentEl) return false;

  if (menuEl.contentEl !== contentEl) {
    menuEl.contentEl = contentEl;
    contentEl.classList.add('menu-content');
    const menuType = menuEl.type || 'overlay';
    contentEl.classList.add(`menu-content-${menuType}`);
  }

  return true;
}

/**
 * Rebind the menu's contentEl synchronously, then open it.
 *
 * The sync rebind is what makes this robust: <ion-menu> captures contentEl
 * once in connectedCallback, and during router.replace transitions that
 * capture can land on a stale element. Rebinding at click time guarantees
 * the menu animates against the active page's <ion-content>.
 *
 * We look the menu up via document.querySelector rather than
 * menuController.get because the controller's internal `menus` array can
 * retain entries for stale menus, and `get(menuId)` returns the FIRST match.
 * This relies on the caller passing a menu-id that is unique to the live
 * mount — see the coursesMountSeq counter in _lessonId.vue, which suffixes
 * menu-id with a per-mount value so the querySelector here matches exactly
 * one element (Ionic Vue keeps previously-mounted <ion-page>s in the DOM
 * with display:none, so without that suffix the stale menu would shadow the
 * live one).
 *
 * menuEl.open() still routes through menuController._setOpen internally
 * (via the menu's setOpen method), so controller-level bookkeeping such as
 * closing other open menus is preserved — we only bypass the broken lookup.
 */
export async function openCoursesMenu(menuId, contentId) {
  if (!menuId || !contentId) return;
  if (!rebindCoursesMenu(menuId, contentId)) {
    console.warn('[courses] menu not ready', { menuId, contentId });
    return;
  }
  const menuEl = document.querySelector(`ion-menu[menu-id="${menuId}"]`);
  if (menuEl?.open) await menuEl.open();
}
